// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__32KcO","inputWrap":"CustomTip_inputWrap__Cegl7"};